import { InputAdornment, TextField } from '@material-ui/core';
import React, { Dispatch, SetStateAction, useState } from 'react';
import VoxelDialog from '../../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionCancel from '../../../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../../components/voxel/Dialogs/VoxelDialogContent';
import { ContentKeywordGq } from '../../../../graphql/projects/models/ContentKeywordGq';
import { ContentTaskGq } from '../../../../graphql/projects/models/ContentTaskGq';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';
import { ContentTaskTableState } from '../Tables/ContentKeywordTable/logic/useContentTaskTableState';

export interface ContentKeywordsNewUrlDialogProps {
  clientUrl: string;
  contentTask: ContentTaskGq;
  tableState: ContentTaskTableState;
  selectedKeywordIds: number[];
  setLocalItems: Dispatch<SetStateAction<ContentKeywordGq[]>>;
  reload: () => Promise<any>;
  openDialog: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
}

const ContentKeywordsNewUrlDialog: React.FC<ContentKeywordsNewUrlDialogProps> = ({
  clientUrl,
  contentTask,
  tableState,
  selectedKeywordIds,
  setLocalItems,
  reload,
  openDialog,
  setOpenDialog,
}) => {
  const [updating, setUpdating] = useState(false);

  const [newUrl, setNewUrl] = useState('');

  const newUrlMutation = projectsApiService.mutations.contentPlan.useSplitToSingleCreateTask();
  const handleNewUrl = () => {
    setUpdating(true);
    setLocalItems((prev) => prev.filter((x) => !selectedKeywordIds.includes(x.id)));
    newUrlMutation({
      contentKeywordIds: selectedKeywordIds,
      projectId: contentTask.projectId,
      contentTaskId: contentTask.id,
      newUrl: newUrl,
    })
      .then(reload)
      .finally(() => {
        setUpdating(false);
        setNewUrl('');
        tableState.handleResetSelection();
        setOpenDialog(false);
      });
  };

  return (
    <VoxelDialog
      maxWClass="max-w-5xl"
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      title="Move to new custom url"
    >
      <VoxelDialogContent>
        <div>
          <TextField
            autoFocus
            placeholder="..."
            variant="outlined"
            size="small"
            fullWidth
            value={newUrl}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {clientUrl}
                  {clientUrl?.endsWith('/') ? '' : '/'}
                </InputAdornment>
              ),
            }}
            onChange={(event) => setNewUrl(event.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>
      </VoxelDialogContent>

      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={() => setOpenDialog(false)} disabled={updating} />
        <VoxelDialogActionSubmit
          title={'Move to new url'}
          onClick={handleNewUrl}
          disabled={updating}
        />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default ContentKeywordsNewUrlDialog;
